/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import dayjs from 'dayjs';

export type TimeUnits = 'days' | 'months' | 'years';

export type TimeAgoType = {
  time: number;
  unit: TimeUnits;
};

export type TimeAgoParams = {
  value: number | string | Date;
  toCompareWith?: number | string | Date;
};

export const getTimeAgo = (dates: TimeAgoParams): TimeAgoType => {
  const date = dayjs(dates.value);
  const today = dates.toCompareWith ? dayjs(dates.toCompareWith) : dayjs();

  const sameYear =
    date.year() === today.year() ||
    (today.year() - date.year() === 1 && date.month() - today.month() > 0);

  const sameMonth =
    date.month() === today.month() ||
    (today.month() - date.month() === 1 && date.date() - today.date() > 0);

  if (sameYear && sameMonth) {
    const daysAgo = today.diff(date, 'day');
    return { time: daysAgo, unit: 'days' };
  }

  if (sameYear || today.diff(date, 'month') < 12) {
    const monthsAgo = today.diff(date, 'month');
    return { time: monthsAgo, unit: 'months' };
  }

  const yearsAgo = today.diff(date, 'year');
  return { time: yearsAgo, unit: 'years' };
};
